module.exports = __webpack_public_path__ + "static/img/strona_005.26bd9012.jpg";